import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import { Link } from 'react-router-dom';

import css from './AboutPage.module.css';
import image from './about-us-1056.jpg';
import { useIntl } from 'react-intl';

const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const intl = useIntl();
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About ',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            {intl.formatMessage({ id: 'AboutPage.AboutPage.title' })}
          </h1>
          <div className={css.contentWrapper}>
            <div className={css.contentMain}>
              <p>{intl.formatMessage({ id: 'AboutPage.AboutPage.paragraphOne' })}</p>
              <p>{intl.formatMessage({ id: 'AboutPage.AboutPage.paragraphTwo' })}</p>
              <p>{intl.formatMessage({ id: 'AboutPage.AboutPage.paragraphThree' })}</p>
              <p>
                {intl.formatMessage({ id: 'AboutPage.AboutPage.paragraphFour' })}
                <Link to="/s">
                  {intl.formatMessage({ id: 'AboutPage.AboutPage.paragraphFourLink1' })}
                </Link>
                {intl.formatMessage({ id: 'AboutPage.AboutPage.paragraphFourCont1' })}
                <Link to="/">
                  {intl.formatMessage({ id: 'AboutPage.AboutPage.paragraphFourLink2' })}
                </Link>
                {intl.formatMessage({ id: 'AboutPage.AboutPage.paragraphFourCont2' })}
              </p>

            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
